export default __webpack_public_path__ + "static/media/img12.31794019.png";